import * as React from 'react';
import { FieldError } from 'react-hook-form';
import DynamicSelect from '../../../Components/Base/DynamicSelect/DynamicSelect';
import { SelectValue } from '../../../Components/Base/Select/Select';
import useTermItemSelect, { TermItemOption } from '../hooks/useTermItemSelect';

export interface TermItemSelectTemplateItem {
	data: TermItemOption;
	value: string;
	selectOption: ({ label, value }: { label: string; value: string }) => void;
}

interface Props {
	onChange?: (value: SelectValue) => void;
	workplaceId?: string;
	value?: SelectValue;
	error?: FieldError;
	termType: string;
	useValue?: boolean;
	placeholder?: string;
	ItemTemplate?: (item: TermItemSelectTemplateItem) => React.ReactElement;
}

const TermItemSelect: React.FC<Props> = ({
	value,
	onChange,
	termType,
	error,
	useValue = false,
	placeholder,
	ItemTemplate,
}) => {
	const { termItemSelectOptions } = useTermItemSelect({
		termType,
		useValue,
	});

	const handleSearchItem = async (
		searchInput: string,
	): Promise<SelectValue[]> => {
		return await termItemSelectOptions(searchInput);
	};

	return (
		<DynamicSelect
			searchItems={handleSearchItem}
			onChange={onChange}
			value={value}
			error={error}
			placeholder={placeholder}
			ItemTemplate={ItemTemplate}
			portal
			showErrorMessage={false}
		/>
	);
};

export default TermItemSelect;
